import { ALERT_ACTION_TYPES_CONFIGURATIONS_MAP } from './AlertTypes.const';
import { ACTION_TYPES_MAP } from '../../../utils/alerts/action-types/action-types.const';

// Public

const getAlertActionTypeConfiguration = (actionTypeId) =>
	ALERT_ACTION_TYPES_CONFIGURATIONS_MAP[actionTypeId] || ALERT_ACTION_TYPES_CONFIGURATIONS_MAP[ACTION_TYPES_MAP.DEFAULT];

const AlertTypeService = {
	getAlertActionTypeConfiguration,
};

export default AlertTypeService;
